import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy connect (baseline)
import { connect } from 'react-redux';
import { makeGetFormattedMessageProps } from '../../redux/modules/locale';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy class component (baseline)
class FormattedMessage extends PureComponent {
    render() {
        //noinspection JSUnusedLocalSymbols - omit properties that do not belong to the span
        const { id, values, options, message, defaultMessage, dispatch, svg, ...rest } = this.props;
        if (svg) return message;

        // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
        return <span {...rest}>{message}</span>;
    }
}

FormattedMessage.propTypes = {
    id: PropTypes.string,
    values: PropTypes.object,

    options: PropTypes.object,
    message: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
    // Inside an SVG: the plain message, without the <span>
    svg: PropTypes.bool
};

export default connect(makeGetFormattedMessageProps)(FormattedMessage);
